import React, { useEffect, useState } from "react";
import { Toast, Empty } from "antd-mobile";
import { getBeanOverview, getBeanDetailPage } from "../../api/searchNew";
import "./index.scss";

// 金额展示：正数带 +，负数自带 -
const formatAmount = (num) => (num >= 0 ? `+${num}` : `${num}`);

const PAGE_SIZE = 10;

const TAB_DETAIL = "detail";
const TAB_MONTH = "month";

const TABS = [
  { key: TAB_DETAIL, label: "明细" },
  { key: TAB_MONTH, label: "按月统计" },
];

const WisdomBeanPage = () => {
  const [searchText, setSearchText] = useState("BJ2601031");
  const [activeTab, setActiveTab] = useState(TAB_DETAIL);

  // 概览数据
  const [overview, setOverview] = useState(null);

  // 明细分页
  const [detailData, setDetailData] = useState({
    count: 0,
    list: [],
  });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const totalPage = Math.ceil(detailData.count / PAGE_SIZE);

  // 查询明细
  const queryDetail = async (pageNo) => {
    try {
      const res = await getBeanDetailPage({
        user_no: searchText.trim(),
        page_no: pageNo,
        page_size: PAGE_SIZE,
      });

      if (res.code === 0) {
        setDetailData(res.data);
      } else {
        Toast.show({ content: res.info || "查询失败", position: "top" });
      }
    } catch (e) {
      console.error(e);
      Toast.show({ content: "网络异常，请稍后重试", position: "top" });
    }
  };

  // 查询概览
  const queryOverview = async () => {
    if (!searchText.trim()) {
      Toast.show({ content: "请输入学号", position: "top" });
      return;
    }

    try {
      setLoading(true);

      const res = await getBeanOverview({
        user_no: searchText.trim(),
      });

      if (res.code !== 0) {
        Toast.show({ content: res.info || "查询失败", position: "top" });
        return;
      }

      setOverview(res.data);
      setPage(1);
      queryDetail(1);
    } catch (e) {
      console.error(e);
      Toast.show({ content: "网络异常，请稍后重试", position: "top" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    queryOverview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="wisdom-bean-page">
      {/* 顶部 */}
      <div className="page-header">
        <svg className="icon">
          <path d="M15 19l-7-7 7-7" />
        </svg>
        <h1 className="title">智慧豆查询</h1>
      </div>

      <div className="page-content">
        {/* 搜索 */}
        <div className="search-wrap">
          <div className="search-input-wrap">
            <input
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search-input"
              placeholder="输入学号"
            />
          </div>
          <button className="btn-query" onClick={queryOverview} disabled={loading}>
            查询
          </button>
        </div>

        <p className="search-tip">支持学号: BJ2601031</p>

        {/* 余额卡片 */}
        <div className="balance-card">
          <div className="card-top">
            <div>
              <p className="card-desc">
                学号: {overview?.userNo || "-"}&nbsp;|&nbsp;昵称:{" "}
                {overview?.nickName || "-"}
              </p>
              <p className="card-label">智慧豆总余额</p>
              <div className="num-wrap">
                <span className="num">{overview?.beanTotal ?? 0}</span>
                <span className="unit">豆</span>
              </div>
            </div>
            <div className="card-icon">💳</div>
          </div>

          <div className="card-bottom">
            <div className="card-item">
              <p className="card-item-label">本月收益</p>
              <p className="card-item-value">
                {formatAmount(overview?.monthBeanAmount ?? 0)}豆
              </p>
            </div>

            <div className="card-item">
              <p className="card-item-label">本月完成任务</p>
              <p className="card-item-value">
                {overview?.monthServiceCount ?? 0}项
              </p>
            </div>
          </div>
        </div>

        {/* 必经之路 */}
        <div className="entrance-card">
          <div className="entrance-left">
            <div className="entrance-icon">📍</div>
            <div>
              <p className="entrance-title">必经之路</p>
              <p className="entrance-desc">完成成长任务，解锁更多智慧豆</p>
            </div>
          </div>
        </div>

        {/* tab */}
        <div className="tabs-wrap">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`tab-item ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* 明细 */}
        {activeTab === TAB_DETAIL && (
          <>
            {detailData.list.length > 0 && (
              <div className="list-info">
                <span>共 {detailData.count} 条记录</span>
                <span>
                  第 {page}/{totalPage || 1} 页
                </span>
              </div>
            )}

            <div className="list-card">
              {detailData.list.length === 0 ? (
                <Empty
                  className="list-empty"
                  imageStyle={{ width: 96 }}
                  description="暂无明细记录"
                />
              ) : (
                <>
                  <div className="list-header">
                    <span>完成任务时间</span>
                    <span>板块</span>
                    <span>服务内容</span>
                    <span>积分</span>
                  </div>

                  {detailData.list.map((item) => (
                    <div key={item.id} className="list-row">
                      <span>{item.jobTime?.substring(0, 7)}</span>
                      <span>{item.mainDepartmentName || "-"}</span>
                      <span>
                        {item.departmentName || ""}-{item.jobName || ""}
                      </span>
                      <span className="row-score">
                        {item.type === 1 ? "+" : "-"}
                        {item.beanAmount}
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>

            {detailData.list.length > 0 && (
              <div className="pagination">
                <button
                  disabled={page <= 1}
                  onClick={() => {
                    const p = page - 1;
                    setPage(p);
                    queryDetail(p);
                  }}
                >
                  上一页
                </button>
                <button
                  disabled={page >= totalPage}
                  onClick={() => {
                    const p = page + 1;
                    setPage(p);
                    queryDetail(p);
                  }}
                >
                  下一页
                </button>
              </div>
            )}
          </>
        )}

        {/* 按月统计 */}
        {activeTab === TAB_MONTH && (
          <>
            <p className="month-tip">累计收益趋势，按年月倒序</p>

            <div className="list-card">
              {overview?.monthStatList?.length ? (
                <>
                  <div className="month-list-header">
                    <span>年月</span>
                    <span>积分</span>
                  </div>

                  {overview.monthStatList.map((item) => (
                    <div className="month-list-row" key={item.month}>
                      <span>
                        {item.month.substring(0, 4)}年{Number(item.month.substring(5))}
                        月
                      </span>
                      <span className="row-score">{formatAmount(item.beanAmount)}豆</span>
                    </div>
                  ))}
                </>
              ) : (
                <Empty
                  className="list-empty"
                  imageStyle={{ width: 96 }}
                  description="暂无月度统计"
                />
              )}
            </div>

            <div className="year-total-card">
              <div className="year-card-header">
                <span>年度累计收获</span>
              </div>
              <div className="year-num-wrap">
                <span className="year-num">{overview?.yearBeanTotal ?? 0}</span>
                <span>豆</span>
              </div>
              <p className="year-card-desc">{new Date().getFullYear()}年以来完成服务任务累计获得</p>
            </div>
          </>
        )}
      </div>

      <div className="fixed-footer">
        <button className="btn-bottom">查看我的必经之路</button>
      </div>
    </div>
  );
};

export default WisdomBeanPage;
